export enum NotificationType {
  error = 'error',
  info = 'info',
  warning = 'warning',
}
